<template>
  <div class="portal-model-form">
    <v-text-field
      v-model="parentPortalModelForm.name"
      label="Nom"
      :rules="rules.nameRules"
    >
    </v-text-field>
    <v-text-field
      v-model="parentPortalModelForm.url"
      label="Chemin"
      :rules="rules.urlRules"
    >
    </v-text-field>
    <v-textarea
      v-model="parentPortalModelForm.configuration"
      label="Configuration"
      :rules="rules.configurationRules"
    ></v-textarea>
  </div>
</template>
<script>
import { computed } from "@vue/composition-api";

export default {
  props: {
    portalModelForm: Object,
    rules: Object,
  },
  setup(props, { emit }) {
    const parentPortalModelForm = computed({
      get: () => props.portalModelForm,
      set: (value) => {
        emit("update:portalModelForm", value);
      },
    });

    return {
      parentPortalModelForm,
    };
  },
};
</script>
